export default Object.freeze({
  // APP_DELETE: 'APP_DELETE',
});
